// Initialize the global LHX object used to push configuration changes
import LHX from 'utils/LHX';
import { initializeWindowResizeListener } from './initializeWindowResizeListener';


export default (store) => {
  LHX.connectToStore(store);
  initializeWindowResizeListener(store, window, screen);
};



/** WEBPACK FOOTER **
 ** ./src/initialize.js
 **/